import type { TimeSeriesPoint } from "~/modules/asset_timeseries_v4/types";

// // // //

const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export function getTrailingAverage(
    points: TimeSeriesPoint[],
    windowDays: number,
): TimeSeriesPoint[] {
    if (windowDays <= 1) {
        return points;
    }

    const datedPoints = points
        .map(([date, value]) => ({
            date,
            timestamp: Date.parse(date),
            value: Number(value),
        }))
        .filter(
            (point) =>
                Number.isFinite(point.timestamp) &&
                Number.isFinite(point.value),
        )
        .sort((a, b) => a.timestamp - b.timestamp);
    const windowDuration = (windowDays - 1) * DAY_IN_MILLISECONDS;
    const averagedPoints: TimeSeriesPoint[] = [];
    const firstTimestamp = datedPoints[0]?.timestamp;
    let windowStartIndex = 0;
    let windowTotal = 0;

    for (let pointIndex = 0; pointIndex < datedPoints.length; pointIndex++) {
        const point = datedPoints[pointIndex];
        windowTotal += point.value;

        while (
            datedPoints[windowStartIndex] &&
            point.timestamp - datedPoints[windowStartIndex].timestamp >
                windowDuration
        ) {
            windowTotal -= datedPoints[windowStartIndex].value;
            windowStartIndex += 1;
        }

        if (
            firstTimestamp !== undefined &&
            point.timestamp - firstTimestamp >= windowDuration
        ) {
            averagedPoints.push([
                point.date,
                windowTotal / (pointIndex - windowStartIndex + 1),
            ]);
        }
    }

    return averagedPoints;
}
